import { Select as NextSelect, type SelectProps } from "@heroui/react";
import { withFormComponent } from "./hoc";

// 设置 displayName 以便组件识别
(NextSelect as React.ComponentType<SelectProps>).displayName = "HeroUI.Select";

export const Select = withFormComponent(NextSelect); 